import classNames from 'classnames/bind';
import * as _ from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import styles from '../../styles.module.scss';
import defaultPic from '../../../../../images/defaultPic.png?as=webp';
import { ApprovedVenueProps } from '../../../../../types';

import Picture from '../../../../../components/Picture/Picture';

const cx = classNames.bind(styles);

const SportApprovedVenues = ({ chosenSport, sportVenues }) =>
  sportVenues.length ? (
    <div className={cx('container', 'detailInfo')}>
      <h1 className={cx('fancyText', 'mt-5', 'mb-4')}>Venues</h1>
      <div className="row mt-3">
        {_.map(sportVenues, (venue, i) => {
          const { shorthandName, sportDetails, image, formatted_address } = venue;
          const description = _.get(
            _.find(sportDetails, ({ sportName }) => sportName === chosenSport),
            'description'
          );
          let imageVenue;
          if (_.get(image, 'url')) {
            imageVenue = (
              <Picture className={cx('venueImg')} src={_.get(image, 'url')} alt="venue" />
            );
          } else {
            imageVenue = <img className={cx('venueImg')} src={defaultPic} alt="venue" />;
          }
          return (
            <div className="col-12 col-md-6 mb-4" key={i}>
              <div className={cx('venueCard')}>
                <div className="col-12 col-md-5 p-0">
                  <h3>{shorthandName} </h3>
                  {/* <img src={pinIcon} alt="pin" className={cx('pin')} /> */}
                  <h4>{formatted_address}</h4>
                  {imageVenue}
                </div>
                <div className="col-12 col-md-7 p-0">
                  <p
                    className={cx('venueDescription')}
                    dangerouslySetInnerHTML={{ __html: description || 'Description coming soon!' }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  ) : (
    <div />
  );

SportApprovedVenues.propTypes = {
  sportVenues: PropTypes.arrayOf(ApprovedVenueProps).isRequired,
  chosenSport: PropTypes.string.isRequired,
};

export default SportApprovedVenues;
